import { useTranslation } from "react-i18next";
// Components
import { HeaderMainDiv, HeaderDiv, Title } from "./styles";

const EvaluationsHeader = () => {
  const [t] = useTranslation("global");

  return (
    <HeaderMainDiv>
      <HeaderDiv>
        <Title width={"150px"}>{t("evaluations").toUpperCase()}</Title>
      </HeaderDiv>
    </HeaderMainDiv>
  );
};

export default EvaluationsHeader;
